import { render, staticRenderFns } from "./GiftConfirmation.vue?vue&type=template&id=2423cb4c&"
import script from "./GiftConfirmation.vue?vue&type=script&lang=ts&"
export * from "./GiftConfirmation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports